var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "80%",
    width: "80%",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42,24A18,18,0,1,1,18.71,6.78a1,1,0,0,1,.58,1.92A16,16,0,1,0,40,24a14.78,14.78,0,0,0-.18-2.36,1,1,0,0,1,2-.32A17.77,17.77,0,0,1,42,24ZM18.58,12.17A13,13,0,1,0,37,24.25a1,1,0,0,0-1-1,1,1,0,0,0-1,1A11,11,0,1,1,19.42,14a1,1,0,1,0-.84-1.82ZM23,19.1V7a1,1,0,0,1,1-1,17.92,17.92,0,0,1,16,9.67l0,0v0h0a.11.11,0,0,1,0,0,1,1,0,0,1-.4,1.28L28.91,23.14A4.82,4.82,0,0,1,29,24a5,5,0,1,1-6-4.9ZM25,8V19.1a5,5,0,0,1,3.17,2.16l9.57-5.45A15.94,15.94,0,0,0,25,8ZM21,24a3,3,0,1,0,3-3A3,3,0,0,0,21,24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.21c51ab351c1da3c10eaa0787fa70af8.svg";
export { ForwardRef as ReactComponent };